var checkoutPage = document.querySelector(
  "body.page-checkout:not(.woocommerce-order-received)"
);

if (checkoutPage) {
  //Redirects to cart if user goes back from Thank You page
  window.onpageshow = function (event) {
    if (event.persisted) {
      window.location.replace("/cart");
    }
  };
  document.addEventListener("DOMContentLoaded", function () {
    const billingAddress = <HTMLInputElement>(
      document.getElementById("billing_address_1")
    );
    const billingCity = <HTMLInputElement>(
      document.getElementById("billing_city")
    );
    const hiddenBillingPhone = document.querySelectorAll(
      "input[name='billing_phone']"
    ) as NodeListOf<HTMLInputElement>;
    const billingAddressWrap = document.getElementById(
      "billing_address_1_field"
    ) as HTMLParagraphElement;

    const addressNotice = document.getElementById(
      "billing_address_1_field_number_notice"
    ) as HTMLElement;

    billingAddressWrap.appendChild(addressNotice);

    //Fix the paypal and phone number field conflict
    hiddenBillingPhone[1]?.remove();

    var billingAddressTimer;
    billingAddress?.addEventListener("change", (e) => {
      clearTimeout(billingAddressTimer);
      billingAddressTimer = setTimeout(function() {
        //document.body.dispatchEvent(new Event("update_checkout"));
        toggleNotice();
      }, 500);
    });

    let previousCityValue = billingCity.value;

    function toggleNotice() {
      if (billingAddress.value.length == 0 || /\d/.test(billingAddress.value)) {
        addressNotice.style.display = "none";
      } else {
        addressNotice.style.display = "block";
      }
    }

    function checkCityChange() {
      const cityValue = billingCity.value;

      if (cityValue !== previousCityValue) {
        //document.body.dispatchEvent(new Event("update_checkout"));
        previousCityValue = cityValue;
      }
    }

    setInterval(checkCityChange, 1000);

    //Adds placeholders to the login form
    const addPlaceholders = () => {
      let username = <HTMLInputElement>(
        document.querySelector(".woocommerce-form-login #username")
      );
      let password = <HTMLInputElement>(
        document.querySelector(".woocommerce-form-login #password")
      );

      if (username) {
        username.placeholder = "Uporabniško ime";
      }

      if (password) {
        password.placeholder = "Geslo";
      }
    };

    const addText = () => {
      //Add label on top of hours selector
      const node = document.createElement("p");
      node.classList.add("wolt_label");
      const textnode = document.createTextNode("Izberite čas dostave");
      node.appendChild(textnode);
      let parrentDiv = <HTMLElement>(
        document.querySelector(".woocommerce-shipping-totals+tr>td")
      );
      parrentDiv?.insertBefore(node, parrentDiv.firstChild);
    };

    /**
     * Observer for order summary section
     */
    let observerCheckout = new MutationObserver(observerCallbackCheckout);

    // @deprecated.
    // Hook "njamito_woocommerce_review_order_after_shipping" has been disbaled.
    function showSubscriptonIfUserExists(email) {
      const ajaxData = (window as any).njamito_ajax;

      if ((window as any).njamito_ajax) {
        let data = new FormData();
        data.append("action", "njamito_check_if_user_exists");
        data.append("email", email);
        data.append("nonce", ajaxData.nonce);

        fetch(ajaxData.ajax_url, {
          method: "POST",
          body: data,
        })
          .then((response) => {
            return response.json();
          })
          .then((jsonResponse) => {
            if (!jsonResponse.success) {
            }

            if (jsonResponse.success) {
              const subscriptionBox = <HTMLElement>(
                document.querySelector(".custom-order__tr")
              );
              if (jsonResponse.data.email_exists) {
                document.body.classList.add("sub-box-visible");
              } else {
                document.body.classList.remove("sub-box-visible");
              }
            }
          });
      }
    }

    function setCheckoutObserver() {
      //Listens for cart form DOM changes
      let cartForm = document.querySelector("#order_review") as HTMLElement;
      if (cartForm) {
        observerCheckout.observe(cartForm, { childList: true });
      }
    }

    function observerCallbackCheckout() {
      let initialContainer = <HTMLTableElement>(
        document.querySelector(
          "body.page-checkout:not(.woocommerce-order-received) .shipping-wrap + .woocommerce-checkout-review-order-table .order-total"
        )
      );
      const subscriptionCheckbox = <HTMLInputElement>(
        document.getElementById("subscriptionCheckbox")
      );

      const intervalOptions = <HTMLSelectElement>(
        document.getElementById("intervalOptions")
      );

      let copyContainer = <HTMLElement>(
        document.querySelector(".order-total-custom")
      );

      // Display or hide wolt availability message
      let woltLabel = <HTMLElement>(
        document.querySelector('label[for="shipping_method_0_wolt_drive"]')
      );

      intervalOptions?.addEventListener("change", (e) => {
        document.body.dispatchEvent(new Event("update_checkout"));
        const ajaxData = (window as any).njamito_ajax;

        if ((window as any).njamito_ajax) {
          let data = new FormData();
          data.append("action", "njamito_set_cart_state_action");
          data.append("activeSubscriptionScheme", intervalOptions.value);
          data.append("nonce", ajaxData.nonce);

          fetch(ajaxData.ajax_url, {
            method: "POST",
            body: data,
          })
            .then((response) => {
              return response.json();
            })
            .then((jsonResponse) => {
              if (!jsonResponse.success) {
                location.reload();
              }

              if (jsonResponse.success) {
                document.body.dispatchEvent(new Event("update_checkout"));
              }
            });
        }
      });

      // @deprecated
      // Hook "njamito_woocommerce_review_order_after_shipping" has been disabled, so no need to listen for subscription events.
      // subscriptionCheckbox?.addEventListener("click", (e) => {
      //   document.body.dispatchEvent(new Event("update_checkout"));

      //   let activeSubscriptionScheme;
      //   if (subscriptionCheckbox.checked) {
      //     activeSubscriptionScheme = "1_week";
      //   } else {
      //     activeSubscriptionScheme = "";
      //   }
      //   const ajaxData = (window as any).njamito_ajax;

      //   if ((window as any).njamito_ajax) {
      //     let data = new FormData();
      //     data.append("action", "njamito_set_cart_state_action");
      //     data.append("activeSubscriptionScheme", activeSubscriptionScheme);
      //     data.append("nonce", ajaxData.nonce);

      //     fetch(ajaxData.ajax_url, {
      //       method: "POST",
      //       body: data,
      //     })
      //       .then((response) => {
      //         return response.json();
      //       })
      //       .then((jsonResponse) => {
      //         if (!jsonResponse.success) {
      //         }

      //         if (jsonResponse.success) {
      //           var event = new Event("update_checkout");
      //           document.body.dispatchEvent(event);
      //         }
      //       });
      //   }
      // });

      // Copy order summary section
      if (copyContainer.innerHTML != undefined) {
        copyContainer.innerHTML = initialContainer.innerHTML;
      }

      addText();
      setCheckoutObserver();
    }

    //Function calls
    addText();
    //Set form DOM change listener
    setCheckoutObserver();
    addPlaceholders();
  });
}
